import { useRef } from 'react';
import { useLanguage } from '../hooks/useLanguage.jsx';

export default function ArtworkCard({ artwork, onOpen }) {
  const { t } = useLanguage();
  const buttonRef = useRef(null);

  return (
    <button
      ref={buttonRef}
      type="button"
      className="artwork-card"
      onClick={() => onOpen(buttonRef.current)}
    >
      <img
        src={artwork.images.thumb}
        alt={t(artwork.alt) || t(artwork.title)}
        loading="lazy"
      />
    </button>
  );
}
